<template v-if="!loading">
  <div v-if="pocs && pocs.length">
    <h3  v-if="editors && editors.editorsPick && editors.editorsPick.title" class="font-weight-bolder text-primary mb-3 h5">
    {{editors.editorsPick.title}}
  </h3>
    <div class="splide newFeatureSlider mb-4" :class="randomId" aria-label="Slider for Highlights der Woche">
      <div class="splide__track mask-container">
        <div class="splide__list">
          <div class="splide__slide"
            v-for="(editorsPick, i) in pocs" :key="i">
            <SinglePocEditors :editorsPick="editorsPick"  :isDevMioActive="isDevMioActive" :realUrl="editorsPick.realUrl" :settingsPerm="settingsPerm" :key="i" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from "@splidejs/splide";
import helperfunctions from "../../services/helperfunctions.js";
import queryAndMutaionService from '../../services/queryAndMutaionService.js';
import SinglePocEditors from './SinglePocEditors.vue';

export default {
  name: "BrandPocEditors",
  components: {
        SinglePocEditors
    },
  data() {
    return {
        randomId: this.generateRandomId(),
        brandSlug: false,
        page: 1,
        loading: false,
        error: false,
        result: null,
        splide: null,
        metaCount: 0,
        currentPage: 1,
        isDevMioActive: false,
        pocs: [],
      };
  },
  props: {
    settingsPerm: Object,
    queryType: String,
    brandComplexSlug: String,
    brandData: Object,
    editors: Array,
  },
  created() {
    if (this.settingsPerm && this.settingsPerm.brandSlug) {
      this.brandSlug = this.settingsPerm.brandSlug;
    }
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
    this.getPocForEditors()
  },
  methods: {

    getPocForEditors() {
      queryAndMutaionService.getPocDataForEditors(this.brandData.slug).then((data) => {
        if (data && 
            data.brandComplex &&
            data.brandComplex.BrandComplex &&
            data.brandComplex.BrandComplex.experiences &&
            data.brandComplex.BrandComplex.experiences.length > 0) {
            this.result = data;
            this.editors.editorsPick.contents.forEach((poc) =>{
              this.pocs.push({...poc, realUrl: helperfunctions.generateUrlForPocs(poc)});
            });
            this.mount_splide();
            }
            this.loading = false;
        }).catch((error) => {
            this.error = error;
            this.loading = false;
      });
      this.page++;
    },

    mount_splide: function () {
    let thiz = this;
      let padding = {
        right: "0rem",
        left: "0rem",
      };
      setTimeout(function () {
          if (!thiz.splide) {
          thiz.splide = new Splide('.'+thiz.randomId, {
            classes: {
              arrows : 'splide__arrows arrows',
              prev  : 'splide__arrow--prev prev',
              next  : 'splide__arrow--next next',
            },
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            rewind: false,
            pagination: false,
            padding:padding,
            breakpoints: {
              1600: {
                perPage: 3,
              },
              1280: {
                perPage: 2,
              },
              991: {
                perPage: 2,
              },
              767: {
                perPage: 1,
              },
              575: {
                perPage: 1,
                arrows: false, 
                start  : 1,
              },
            },   
          });
          thiz.splide.mount();
          // thiz.addMovedEventListener(); 
          } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
          }
      }, 100);
    },

    generateRandomId() {
      const randomSuffix = Math.random().toString(36).substring(2);
      return 'a' + randomSuffix; 
    },
  
  },


};
</script>

<style scoped>
  .mask-container {
  position: relative;
  overflow: hidden;
  }  
  .mask-container::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 94%;
    transform: translateX(-50%);
    width: 22%;
    background: linear-gradient(to right, transparent, white); 
    filter: blur(10px);
  }
  .prev {
        left: 68.5rem !important;
        background-color: transparent!important;
        outline: none !important;
    }
    
    .next {
        right: -0.5rem !important;
        background-color: transparent!important;
        outline: none !important;
    }
    
    .arrows {
        position: relative !important;
        top: -20px;
        outline: none !important;
    }

    .splide__arrow:focus-visible {
    outline: none !important;
    }

    .splide__arrow:focus-visible {
    outline: 0px !important;
    outline-offset: 0px !important;
}

    @media screen and (max-width: 1679px) {
        .prev {
            left: 54rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 1359px) {
        .prev {
            left: 46rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 1199px) {
        .prev {
            left: 38rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 767px) {
        .prev {
            left: 26rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
</style>